import React, {useRef} from 'react'
import {useWidgetHost, useWidgetState} from '../../../../hooks/state-provider'
import {getDaysInGridMonth, getReferenceMonth, getWeekdaysFromStartWeekday} from '../../../../selectors/calendar-layout'
import {getBorderStyle} from '../../../../utils/calendar'
import {CalendarCell} from './cell'
import {MonthlyCalendarCellRefs, MonthlyCalendarCellSizes} from './interfaces'
import s from './monthly-calendar-grid.scss'
import {MonthlyCalendarPopup} from './popup'

export const MonthlyCalendarGrid = () => {
  const cellRefs = useRef<MonthlyCalendarCellRefs>({})
  const referencedMonth = useWidgetState(getReferenceMonth)
  const shownDays = useWidgetState(state => getDaysInGridMonth(state, referencedMonth))
  const weekdayNames = useWidgetState(getWeekdaysFromStartWeekday)
  const host = useWidgetHost()
  const borderStyle = getBorderStyle({host})

  const getCellSizes = (): MonthlyCalendarCellSizes =>
    Object.entries(cellRefs.current).reduce((cellSizes, [week, weekRefs]) => {
      cellSizes[week] = Object.entries(weekRefs).reduce((weekSizes, [weekDay, ref]) => {
        const {clientWidth: width, clientHeight: height} = (ref as HTMLElement) ?? {}
        weekSizes[weekDay] = {width, height}

        return weekSizes
      }, {})

      return cellSizes
    }, {})

  const registerCellContainerRef = (week: number, weekDay: number, ref: HTMLElement) => {
    cellRefs.current[week] = cellRefs.current[week] || {}
    cellRefs.current[week][weekDay] = ref
  }

  return (
    <div className={s.grid}>
      <div className={s.weekDays}>
        {weekdayNames.map(name => (
          <div className={s.weekDay} key={name}>
            {name}
          </div>
        ))}
      </div>
      <div className={s.days}>
        {new Array(6).fill(null).map((_, week) => (
          <div className={s.week} style={borderStyle} key={week}>
            {new Array(7).fill(null).map((__, weekDay) => (
              <CalendarCell
                key={shownDays[week * 7 + weekDay]}
                timestamp={shownDays[week * 7 + weekDay]}
                week={week}
                weekDay={weekDay}
                registerContainerRef={registerCellContainerRef}
              />
            ))}
          </div>
        ))}
        <MonthlyCalendarPopup getCellSizes={getCellSizes} />
      </div>
    </div>
  )
}
